import { Pipe, PipeTransform } from '@angular/core';
import { FieldHistory } from 'src/app/shared';

@Pipe({
  name: 'isTaskEditorField'
})

// Input: History field
// Output: Editor field || null
export class IsTaskEditorFieldPipe implements PipeTransform {
  transform(field: string): string {
    const fields = [FieldHistory.description, FieldHistory.comment];
    return fields.find(el => el === field);
  }
}
